<script setup lang="ts">
import rules from 'loans/services/rules'

defineProps<{
  content: any
}>()

const values = ref<any>({})
const store = useFormStore()
async function submit(submitValues: any) {
  const [_street, streetName, ...streetNumber] = submitValues.street.match(/^(.+) ([1-9][0-9]*[a-z]?)(\/[1-9][0-9]*[a-z]?)?$/) || []
  submitValues.streetName = streetName
  submitValues.streetNumber = streetNumber.join('')
  submitValues.zipCode = submitValues.zipCode.toString()

  Object.assign(store.values, { ...submitValues })

  await store.updateDemand(true)
}

const isCompleted = computed(() => !!(values.value.street && values.value.city && values.value.zipCode))
</script>

<template>
  <FormStep v-model="values" :is-completed="isCompleted" :submit="submit">
    <template #active>
      <div class="flex flex-col gap-5 p-5 bg-white border-gray-light">
        <h2>{{ content.addressHeader }}</h2>
        <div>{{ content.addressText }}</div>
        <FormFieldAddress group="1" name="street" type="address-street-and-number" />
        <FormFieldAddress group="1" name="city" type="address-city" />
        <FormFieldAddress
          group="1"
          name="zipCode"
          type="address-zip"
          :mask="{ mask: Number, scale: 0, max: 99999 }"
          :rules="rules.zipCode"
        />
        <BaseButton :text="content.addressButtonText" :loading="store.loading" block submit />
      </div>
    </template>
    <template #incomplete>
      <div class="bg-gray bg-opacity-15 p-5 text-lg text-gray-dark font-bold ">
        {{ content.addressHeader }}
      </div>
    </template>

    <template #complete="{ editStep, mappedValues }">
      <div class="flex flex-col gap-3 bg-gray-300 bg-opacity-20 px-5 py-10 ">
        <div class="flex justify-between items-center">
          <div class="flex font-bold text-lg items-center">
            <span class="mr-3 text-success"><AppIcon icon="fal-check-circle" size="28" /></span>
            <span>{{ content.addressHeader }}</span>
          </div>
          <div class="flex text-primary items-center cursor-pointer" @click="editStep">
            <AppIcon
              icon="far-pencil"
              size="16"
            />
            <span class="ml-1">Upravit</span>
          </div>
        </div>
        <div class="flex flex-col flex-grow gap-1 text-gray-dark">
          <div class="flex flex-col mt-2 md:flex-row md:justify-between md:items-center md:mt-0">
            <span class="whitespace-nowrap">{{ content.addressHeader }}</span>
            <span class="font-medium md:text-right">{{ mappedValues.street }}, {{ mappedValues.zipCode }} {{ mappedValues.city }}</span>
          </div>
        </div>
      </div>
    </template>
  </FormStep>
</template>
